/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Label/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Label({
  children,
  viewPath = "/DesignSystem/PatientImageCard/Label"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let patientImageLabelValueData = fromData.useDataValue({ viewPath,
context: 'patient_image',
path: 'label',
})
  return (<React.Fragment
>
<div
  data-testid="Label.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-5hnkT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-5hnkT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-5hnkT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-5hnkT': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="patient_image.label"
 text={patientImageLabelValueData}
 weight="bold"
 fontSize={9}
/>
</div>
{children}
</React.Fragment>)
}